import React from 'react';
import { useVideosListQuery } from 'src/modules/videos/hooks/useVideosListQuery';
import { VideoHeroListSectionRender } from 'src/modules/materials/components/ShowcasePage/renderers/VideoHeroListSectionRender';
import {
  BaseShowcaseQuerySectionData,
  ShowcaseListRenderComponentType,
} from 'src/modules/materials/models/showcase';
import { VideoEntityBasic } from 'src/models/directus';
import { videosBasicGqlQuery } from 'src/modules/videos/graphql/videos-basic.query';

export const VideoHeroListQueryContainer = ({
  section,
  render: Render = VideoHeroListSectionRender,
}: {
  section: BaseShowcaseQuerySectionData;
  render?: ShowcaseListRenderComponentType<VideoEntityBasic>;
}) => {
  const videos = useVideosListQuery(videosBasicGqlQuery, section.variables);

  return (
    <Render
      section={section}
      items={videos.data}
      isLoading={videos.isLoading}
    />
  );
};
